export default __webpack_public_path__ + "static/media/stocks.0dc1d110.png";